module.exports = "/desktop-app/assets/img/loading.png?98b478736d00a1e4a344eb1032feb689";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/images/icon/loading.png
// module id = 9Kw9
// module chunks = 1